export type IdentifierLookupState =
  | { status: "idle" }
  | { status: "pending" }
  | { status: "found"; name: string }
  | { status: "notFound" };

export const isLikelyCompanyNumber = (value: string): boolean => {
  const stripped = value.replace(/\s/g, "");
  return /^[A-Z0-9]{6,8}$/i.test(stripped);
};

export const isLikelyVatNumber = (value: string): boolean => {
  const stripped = value.replace(/[\s-]/g, "").toUpperCase();
  return /^(GB)?\d{9}(\d{3})?$/.test(stripped);
};

type CreditsafeProfileFields = {
  vatNo?: string;
  vatNoSkipped?: boolean;
  creditsafeCompanyId?: string;
  creditsafe?: {
    isAvailable?: boolean;
    matchedBy?: "vatNo" | "regNo";
    matchedNumber?: string;
    companyId?: string;
    company?: { id?: string; name?: string };
    vatNo?: string;
  };
};

export const isCreditsafeVatVerified = (
  businessProfile?: CreditsafeProfileFields | null,
) => {
  const check = businessProfile?.creditsafe;
  const vatNo = businessProfile?.vatNo;
  if (
    businessProfile?.vatNoSkipped ||
    !vatNo ||
    !check?.isAvailable ||
    !check.company?.name
  ) {
    return false;
  }
  if (check.matchedBy === "vatNo" && check.matchedNumber === vatNo) {
    return true;
  }
  // Legacy soft-compat: pre-unification nested shape used vatNo as the lookup key.
  if (!check.matchedBy && check.vatNo === vatNo) {
    return true;
  }
  return false;
};

export const getCreditsafeCompanyId = (
  businessProfile?: CreditsafeProfileFields | null,
) =>
  businessProfile?.creditsafe?.companyId ||
  businessProfile?.creditsafe?.company?.id ||
  businessProfile?.creditsafeCompanyId;
